import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { useQuery } from "react-apollo";
import { Control, Column, Input, Label, Field } from "rbx";
import {
  CompanyLocationSelect,
  VendorSelect,
  SystemCodeSelect,
  BooleanInput
} from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";
import { SINGLE_VENDOR_QUERY } from "../../../graphql/Vendors/Vendors.graphql";
import { SINGLE_ITEM_QUERY } from "../../../graphql/Items/Items.graphql";

const DEFAULT_FILTERS = {
  TransDt_gte: new Date().setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24 * 365,
  Posted: false
};
function ItemTransactionFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({
    ...filters
  });
  const [dateFlag, setDateFlag] = useState(false);

  const ItemData = useQuery(SINGLE_ITEM_QUERY, {
    variables: {
      where: {
        RecId:
          typeof inputs.ItemRecIdRef === "number" ? inputs.ItemRecIdRef : null
      }
    }
  });

  const VendorData = useQuery(SINGLE_VENDOR_QUERY, {
    variables: {
      where: {
        RecId:
          typeof inputs.VendorRecIdRef === "number"
            ? inputs.VendorRecIdRef
            : null
      }
    }
  });

  const handleChange = e => {
    const updates = { ...inputs };
    if (e.value && !e.target && e.name) {
      updates[e.name] = {
        ...e,
        label: e.label.replace(`- ${e.otherLabel}`, "")
      };
      if (e.name === "VendorRecIdRef") {
        updates.VendorNameRecIdRef = {
          ...e,
          label: e.otherLabel
        };
      } else if (e.name === "VendorNameRecIdRef") {
        updates.VendorRecIdRef = {
          ...e,
          label: e.otherLabel
        };
      }
    } else if (e.target.name === "LocRecIdRef") {
      updates[e.target.name] = parseInt(e.target.value);
    } else {
      updates[e.target.name] =
        e.target.type === "checkbox" ? e.target.checked : e.target.value;
    }
    setInputs(prev => ({ ...prev, ...updates }));
  };

  useEffect(() => {
    // Setting up the default dates to filter
    if (inputs && !inputs.TransDt_gte) {
      setInputs({
        ...inputs,
        TransDt_gte: new Date().setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24 * 365
      });
    }
    if (
      inputs &&
      inputs.VendorRecIdRef &&
      typeof inputs.VendorRecIdRef === "number" &&
      VendorData.data &&
      VendorData.data.Vendor &&
      !VendorData.loading
    ) {
      const updates = { ...inputs };
      updates.VendorRecIdRef = {
        value: VendorData.data.Vendor.RecId,
        name: "VendorRecIdRef",
        label: `${VendorData.data.Vendor.VendorNo} - ${VendorData.data.Vendor.Name}`
      };
      updates.VendorNameRecIdRef = {
        value: VendorData.data.Vendor.RecId,
        name: "VendorNameRecIdRef",
        label: `${VendorData.data.Vendor.Name} - ${VendorData.data.Vendor.VendorNo}`
      };
      setInputs({ ...updates });
    }
    if (!dateFlag) {
      setInputs({
        ...inputs,
        TransDt_gte: new Date(inputs.TransDt_gte)
      });
      setDateFlag(true);
    }
  }, [
    inputs,
    ItemData.data,
    ItemData.loading,
    VendorData.data,
    VendorData.loading,
    dateFlag
  ]);

  const handleDateChange = e => {
    const updates = { ...inputs };

    const { value } = e.target;
    updates[e.target.name] = value;

    setInputs({ ...updates });
  };

  const handleClose = () => onClose(onFilter(inputs));

  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...DEFAULT_FILTERS }));

  return (
    <div style={{ width: 800, maxWidth: "90vw" }}>
      <Column.Group>
        <Column>
          <Control expanded>
            <SystemCodeSelect
              label="Transaction Type"
              name="TransTypeRecIdRef"
              value={inputs.TransTypeRecIdRef}
              where={{ CodeName: "InvMovementType" }}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Control expanded>
            <Label>Item No</Label>
            <Input
              name="ItemNo_contains"
              type="text"
              value={inputs.ItemNo_contains}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Control expanded>
            <Label>Item Description</Label>
            <Input
              name="ItemDescription_contains"
              type="text"
              value={inputs.ItemDescription_contains}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Control>
            <Label>Batch Number</Label>
            <Input
              name="BatchNo"
              type="number"
              value={inputs.BatchNo}
              onChange={handleChange}
            />
          </Control>
        </Column>
      </Column.Group>
      <Column.Group>
        <Column>
          <Control>
            <VendorSelect
              orderByNumber
              isLoading={typeof inputs.VendorRecIdRef !== "number"}
              label="Vendor Number"
              name="VendorRecIdRef"
              value={inputs.VendorRecIdRef}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Control>
            <VendorSelect
              isLoading={typeof inputs.VendorRecIdRef !== "number"}
              label="Vendor Name"
              name="VendorNameRecIdRef"
              value={inputs.VendorNameRecIdRef}
              onChange={handleChange}
            />
          </Control>
        </Column>

        <Column>
          <Control>
            <Label>PO Number</Label>
            <Input
              name="PONo"
              type="text"
              value={inputs.PONo}
              onChange={handleChange}
            />
          </Control>
        </Column>
      </Column.Group>
      <Column.Group>
        <Column>
          <Control>
            <CompanyLocationSelect
              firstOptionEnabled
              icon="globe"
              label="Location"
              name="LocRecIdRef"
              value={inputs.LocRecIdRef}
              variables={{ Active: true }}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Control>
            <Label>Start Date</Label>
            <Input
              name="TransDt_gte"
              type="date"
              value={
                inputs.TransDt_gte
                  ? moment(inputs.TransDt_gte).format("YYYY-MM-DD")
                  : ""
              }
              onChange={handleDateChange}
            />
          </Control>
        </Column>
        <Column>
          <Control>
            <Label>End Date</Label>
            <Input
              name="TransDt_lte"
              type="date"
              value={
                inputs.TransDt_lte
                  ? moment(inputs.TransDt_lte).format("YYYY-MM-DD")
                  : ""
              }
              onChange={handleDateChange}
            />
          </Control>
        </Column>
        <Column>
          <Field kind="group">
            <Control>
              <Label>Posted</Label>
              <BooleanInput
                name="Posted"
                value={inputs.Posted}
                onChange={handleChange}
              />
            </Control>
            <Control>
              <Label>Unposted</Label>
              <BooleanInput
                name="Unposted"
                value={inputs.Unposted}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
}
ItemTransactionFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
ItemTransactionFilters.defaultProps = {
  filters: {}
};
export default ItemTransactionFilters;
